import React, { useState, useEffect, useMemo } from "react";
import { usePermissions } from "../../../contexts/PermissionContext";
import {
  AuditOutlined,
  DashboardOutlined,
  DollarOutlined,
  FieldTimeOutlined,
  FileDoneOutlined,
  LaptopOutlined,
  LogoutOutlined,
  NotificationOutlined,
  ProjectOutlined,
  SafetyCertificateOutlined,
  SecurityScanOutlined,
  SettingOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
  LockOutlined,
  DownOutlined,
  FileTextOutlined,
  FolderOutlined,
  RobotOutlined,
  CommentOutlined,
  UsergroupAddOutlined,
  GlobalOutlined,
  UserAddOutlined,
  QuestionCircleOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import NotificationBell from "../../../components/NotificationBell/NotificationBell";
import { Breadcrumb, Button, Layout, Menu, theme, Dropdown, Space, Avatar, Modal, Form, Input, message } from "antd";
import { API_CONST } from "../../../const";
import { AdminDashboardWrapper } from "./AdminDashboard.style";
// @ts-ignore
import Logo from "./../../../assets/logo.svg";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Overview from "../Overview/Overview";
import RolePermission from "../RolePermission/RolePermission";
import UserManagement from "../UserManagement/UserManagement";
import TalentProfiles from "../TalentProfiles/TalentProfiles";
import AddTalentProfile from "../TalentProfiles/AddTalentProfile/AddTalentProfile";
import AdminTalentDetails from "../TalentProfiles/TalentDetails/TalentDetails";
import TalentDocuments from "../TalentProfiles/TalentDocuments/TalentDocuments";
import JobRequirments from "../JobRequirments/JobRequirments";
import PostNewJob from "../JobRequirments/PostNewJob";
import AdminJobDetails, { AdminJobHiredTalents, AdminJobFullDetails } from "../JobRequirments/JobDetails";
import ApprovalProcess from "../ApprovalProcess/ApprovalProcess";
import TalentsHired from "../TalentsHired/TalentsHired";
import AddHiringRecord from "../TalentsHired/AddHiringRecord/AddHiringRecord";
import Timesheet from "../Timesheet/Timesheet";
import Finance from "../Finance/Finance";
import Settings from "../Settings/Settings";
import Account from "../../../components/Account/Account";
import OrganizationProfile from "../Organization/OrganizationProfile";
import CompanyDetails from "../Organization/CompanyDetails";
import UserProfileView from "../UserManagement/UserProfileView";
import AdminEngagements from "../Engagements/AdminEngagements";
import AdminEngagementDetails from "../Engagements/AdminEngagementDetails";
import AdminCreateEngagement from "../Engagements/AdminCreateEngagement";
import AdminProjects from "../Projects/AdminProjects";
import AdminProjectDetails from "../Projects/AdminProjectDetails";
import AdminCreateProject from "../Projects/AdminCreateProject";
import AdminAIProjectAssessment from "../Projects/AdminAIProjectAssessment";
import AdminCreateProjectFromAssessment from "../Projects/AdminCreateProjectFromAssessment";
import AdminAssessments from "../Assessments/AdminAssessments";
import AdminAssessmentDetail from "../Assessments/AdminAssessmentDetail";
import AdminIssuesFeedback from "../IssuesFeedback/AdminIssuesFeedback";
import TeamMembers from "../../Shared/TeamMembers/TeamMembers";
import AdminPartnerRelations from "../PartnerRelations/AdminPartnerRelations";
import AdminHelpCenter from "../HelpCenter/AdminHelpCenter";
import IDVerification from "../IDVerification/IDVerification";
import AdminInterviewRequests from "../InterviewRequests/AdminInterviewRequests";
import AdminSubmittedProfiles from "../SubmittedProfiles/AdminSubmittedProfiles";
import AdminComplianceDocuments from "../ComplianceDocuments/AdminComplianceDocuments";
import AdminReferrals from "../Referrals/AdminReferrals";
import AdminTalentPerformance from "../TalentPerformance/AdminTalentPerformance";
import AdminTalentPerformanceDetail from "../TalentPerformance/AdminTalentPerformanceDetail";

const { Header, Content, Sider } = Layout;

const items1 = ["1", "2", "3"].map((key) => ({
  key,
  label: `nav ${key}`,
}));

const getSideBarMenu = () => [
  { key: "/admin", label: "Dashboard", icon: <DashboardOutlined /> },
  {
    key: "users-roles",
    label: "Users & Roles",
    icon: <TeamOutlined />,
    children: [
      {
        key: "/admin/role-permission",
        label: "Roles & Permissions",
        icon: <SecurityScanOutlined />,
      },
      {
        key: "/admin/user-management",
        label: "User Management",
        icon: <UserOutlined />,
      },
      {
        key: "/admin/team-members",
        label: "Team Members",
        icon: <UsergroupAddOutlined />,
      },
      {
        key: "/admin/referrals",
        label: "Referrals",
        icon: <UserAddOutlined />,
      },
    ],
  },
  {
    key: "requirements",
    label: "Requirements",
    icon: <ProjectOutlined />,
    children: [
      {
        key: "/admin/engagements",
        label: "Engagements",
        icon: <ProjectOutlined />,
      },
      {
        key: "/admin/assessments",
        label: "Assessments",
        icon: <RobotOutlined />,
      },
      {
        key: "/admin/projects",
        label: "Projects",
        icon: <FolderOutlined />,
      },
      {
        key: "/admin/job-requirments",
        label: "Job Requirements",
        icon: <FileDoneOutlined />,
      },
      {
        key: "/admin/interview-requests",
        label: "Interview Requests",
        icon: <NotificationOutlined />,
      },
      {
        key: "/admin/submitted-profiles",
        label: "Submitted Profiles",
        icon: <SnippetsOutlined />,
      },
    ],
  },
  {
    key: "talents",
    label: "Talents",
    icon: <AuditOutlined />,
    children: [
      {
        key: "/admin/talent-profiles",
        label: "Talents Profiles",
        icon: <AuditOutlined />,
      },
      {
        key: "/admin/talents-hired",
        label: "Talents Hired",
        icon: <TeamOutlined />,
      },
      {
        key: "/admin/talents/verification",
        label: "Verification",
        icon: <SafetyCertificateOutlined />,
      },
      {
        key: "/admin/talents/compliance-docs",
        label: "Compliance Docs",
        icon: <FileTextOutlined />,
      },
      {
        key: "/admin/talents/performance",
        label: "Performance",
        icon: <StarOutlined />,
      },
    ],
  },
  {
    key: "billing-finance",
    label: "Billing & Finance",
    icon: <DollarOutlined />,
    children: [
      {
        key: "/admin/timesheet",
        label: "Timesheet",
        icon: <FileTextOutlined />,
      },
      {
        key: "/admin/finance",
        label: "Finance",
        icon: <DollarOutlined />,
      },
    ],
  },
  {
    key: "/admin/partner-relations",
    label: "Partner Relations",
    icon: <GlobalOutlined />,
  },
  {
    key: "/admin/approval-process",
    label: "Approval Process",
    icon: <FieldTimeOutlined />,
  },
  {
    key: "/admin/issues-feedback",
    label: "Issues & Feedback",
    icon: <CommentOutlined />,
  },
  {
    key: "/admin/help-center",
    label: "Help Center",
    icon: <QuestionCircleOutlined />,
  },
];

const sideBarMenu2 = [
  { key: "/admin/settings", label: "Settings", icon: <SettingOutlined /> },
  { key: "/logout", label: "Logout", icon: <LogoutOutlined /> },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const [passwordForm] = Form.useForm();
  const [openKeys, setOpenKeys] = useState([]);
  const { canAccessMenu, loading: permissionsLoading, refreshPermissions } = usePermissions();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("userRole")?.toLowerCase();
    
    if (!token || userRole !== "admin") {
      navigate("/", { replace: true });
    } else {
      refreshPermissions();
    }
  }, [navigate, refreshPermissions]);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/admin/role-permission") || path.includes("/admin/user-management") || path.includes("/admin/team-members") || path.includes("/admin/referrals")) {
      setOpenKeys(["users-roles"]);
    } else if (path.includes("/admin/engagements") || path.includes("/admin/assessments") || 
               path.includes("/admin/projects") || path.includes("/admin/job-requirments") ||
               path.includes("/admin/interview-requests") || path.includes("/admin/submitted-profiles")) {
      setOpenKeys(["requirements"]);
    } else if (path.includes("/admin/talent-profiles") || path.includes("/admin/talents-hired") || path.includes("/admin/talents/verification") || path.includes("/admin/talents/compliance-docs") || path.includes("/admin/talents/performance")) {
      setOpenKeys(["talents"]);
    } else if (path.includes("/admin/timesheet") || path.includes("/admin/finance")) {
      setOpenKeys(["billing-finance"]);
    }
  }, [location.pathname]);

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const sideBarMenu = useMemo(() => getSideBarMenu(), []);

  const filteredSideBarMenu = useMemo(() => {
    if (permissionsLoading) return [];
    return sideBarMenu.map(item => {
      if (item.children) {
        const filteredChildren = item.children.filter(child => canAccessMenu(child.key));
        if (filteredChildren.length === 0) return null;
        return { ...item, children: filteredChildren };
      }
      return canAccessMenu(item.key) ? item : null;
    }).filter(Boolean);
  }, [canAccessMenu, permissionsLoading, sideBarMenu]);

  const filteredSideBarMenu2 = useMemo(() => {
    if (permissionsLoading) return sideBarMenu2.filter(item => item.key === '/logout');
    return sideBarMenu2.filter(item => {
      if (item.key === '/logout') return true;
      return canAccessMenu(item.key);
    });
  }, [canAccessMenu, permissionsLoading]);

  const handlePasswordSubmit = async () => {
    try {
      const values = await passwordForm.validateFields();
      
      if (values.newPassword !== values.confirmPassword) {
        message.error("New password and confirm password do not match");
        return;
      }

      setChangingPassword(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(API_CONST.CHANGE_MY_PASSWORD, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
          confirmPassword: values.confirmPassword,
        }),
      });

      if (response.status === 401 || response.status === 403) {
        message.error("Session expired. Please login again.");
        localStorage.removeItem("authToken");
        window.location.href = "/";
        return;
      }

      const data = await response.json();
      if (response.ok) {
        message.success("Password changed successfully!");
        setChangePasswordVisible(false);
        passwordForm.resetFields();
      } else {
        message.error(data.message || "Failed to change password");
      }
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      message.error("Failed to change password. Please try again.");
    } finally {
      setChangingPassword(false);
    }
  };

  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === "/admin" || path === "/admin/") return "/admin";
    if (path.startsWith("/admin/role-permission")) return "/admin/role-permission";
    if (path.startsWith("/admin/user-management")) return "/admin/user-management";
    if (path.startsWith("/admin/team-members")) return "/admin/team-members";
    if (path.startsWith("/admin/referrals")) return "/admin/referrals";
    if (path.startsWith("/admin/engagements")) return "/admin/engagements";
    if (path.startsWith("/admin/projects")) return "/admin/projects";
    if (path.startsWith("/admin/assessments")) return "/admin/assessments";
    if (path.startsWith("/admin/talent-profiles")) return "/admin/talent-profiles";
    if (path.startsWith("/admin/job-requirments")) return "/admin/job-requirments";
    if (path.startsWith("/admin/talents-hired")) return "/admin/talents-hired";
    if (path.startsWith("/admin/talents/verification")) return "/admin/talents/verification";
    if (path.startsWith("/admin/talents/performance")) return "/admin/talents/performance";
    if (path.startsWith("/admin/talents/compliance-docs")) return "/admin/talents/compliance-docs";
    if (path.startsWith("/admin/timesheet")) return "/admin/timesheet";
    if (path.startsWith("/admin/finance")) return "/admin/finance";
    if (path.startsWith("/admin/partner-relations")) return "/admin/partner-relations";
    if (path.startsWith("/admin/interview-requests")) return "/admin/interview-requests";
    if (path.startsWith("/admin/submitted-profiles")) return "/admin/submitted-profiles";
    if (path.startsWith("/admin/approval-process")) return "/admin/approval-process";
    if (path.startsWith("/admin/settings")) return "/admin/settings";
    if (path.startsWith("/admin/issues-feedback")) return "/admin/issues-feedback";
    if (path.startsWith("/admin/help-center")) return "/admin/help-center";
    if (path.startsWith("/admin/account")) return "";
    return "/admin";
  };

  const handleClick = (e) => {
    if (e.key === "/logout") {
      localStorage.removeItem("authToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userName");
      navigate("/", { replace: true });
    } else {
      if (canAccessMenu(e.key)) {
        navigate(e.key);
      }
    }
  };

  const profileMenuItems = [
    {
      key: 'account',
      label: 'View Account',
      icon: <UserOutlined />,
    },
    {
      key: 'company',
      label: 'View Company',
      icon: <TeamOutlined />,
    },
    {
      key: 'change-password',
      label: 'Change Password',
      icon: <LockOutlined />,
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
    },
  ];

  const handleProfileMenuClick = ({ key }) => {
    if (key === 'logout') {
      localStorage.removeItem("authToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userName");
      navigate("/", { replace: true });
    } else if (key === 'account') {
      navigate("/admin/account");
    } else if (key === 'company') {
      navigate("/admin/company-details");
    } else if (key === 'change-password') {
      setChangePasswordVisible(true);
    }
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  return (
    <AdminDashboardWrapper>
      <Layout>
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            background: "#191919",
            padding: "0 24px",
            justifyContent: "space-between",
          }}
        >
          <img src={Logo} alt="logo" style={{ height: '35px', width: 'auto' }} />
          
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <NotificationBell />
            <Dropdown 
              menu={{ items: profileMenuItems, onClick: handleProfileMenuClick }}
              placement="bottomRight"
            >
              <Avatar
                style={{
                  backgroundColor: "#00d9a9",
                  cursor: "pointer",
                }}
                icon={<UserOutlined />}
              />
            </Dropdown>
          </div>
        </Header>
        <Layout>
          <Sider
            width={200}
            style={{
              background: "#272727",
            }}
            className="side-navbar"
          >
            <Menu
              mode="inline"
              selectedKeys={[getSelectedKey()]}
              openKeys={openKeys}
              onOpenChange={handleOpenChange}
              style={{
                borderRight: 0,
              }}
              items={filteredSideBarMenu}
              onClick={handleClick}
            />

            <Menu
              mode="inline"
              selectedKeys={[getSelectedKey()]}
              style={{
                borderRight: 0,
              }}
              items={filteredSideBarMenu2}
              onClick={handleClick}
            />
          </Sider>
          <Layout
            style={{
              padding: "30px",
              overflow: "auto",
              height: "90vh",
            }}
          >
            <Routes>
              <Route path="*" element={<Overview />} />
              <Route path="/role-permission" element={<RolePermission />} />
              <Route path="/user-management" element={<UserManagement />} />
              <Route path="/team-members" element={<TeamMembers />} />
              <Route path="/referrals" element={<AdminReferrals />} />
              <Route path="/engagements" element={<AdminEngagements />} />
              <Route path="/engagements/create" element={<AdminCreateEngagement />} />
              <Route path="/engagements/edit/:id" element={<AdminCreateEngagement />} />
              <Route path="/engagements/details/:id" element={<AdminEngagementDetails />} />
              <Route path="/projects" element={<AdminProjects />} />
              <Route path="/projects/create" element={<AdminCreateProject />} />
              <Route path="/projects/create/ai-assessment" element={<AdminAIProjectAssessment />} />
              <Route path="/projects/create/from-assessment" element={<AdminCreateProjectFromAssessment />} />
              <Route path="/projects/edit/:id" element={<AdminCreateProject />} />
              <Route path="/projects/details/:id" element={<AdminProjectDetails />} />
              <Route path="/assessments" element={<AdminAssessments />} />
              <Route path="/assessments/:id" element={<AdminAssessmentDetail />} />
              <Route path="/talent-profiles" element={<TalentProfiles />} />
              <Route
                path="/talent-profiles/add-new-profile"
                element={<AddTalentProfile />}
              />
              <Route
                path="/talent-profiles/details/:talentId"
                element={<AdminTalentDetails />}
              />
              <Route
                path="/talent-profiles/documents/:talentId"
                element={<TalentDocuments />}
              />
              <Route path="/job-requirments" element={<JobRequirments />} />
              <Route
                path="/job-requirments/new-job-post"
                element={<PostNewJob />}
              />
              <Route
                path="/job-requirments/edit-job/:jobId"
                element={<PostNewJob />}
              />
              <Route
                path="/job-requirments/job-details/:jobId"
                element={<AdminJobDetails />}
              />
              <Route
                path="/job-requirments/job-full-details/:jobId"
                element={<AdminJobFullDetails />}
              />
              <Route
                path="/job-requirments/hired-talents/:jobId"
                element={<AdminJobHiredTalents />}
              />
              <Route path="/talents/verification" element={<IDVerification />} />
              <Route path="/talents/compliance-docs" element={<AdminComplianceDocuments />} />
              <Route path="/talents/performance" element={<AdminTalentPerformance />} />
              <Route path="/talents/performance/:talentId" element={<AdminTalentPerformanceDetail />} />
              <Route path="/talents-hired" element={<TalentsHired />} />
              <Route
                path="/talents-hired/add"
                element={<AddHiringRecord />}
              />
              <Route
                path="/talents-hired/edit/:id"
                element={<AddHiringRecord />}
              />
              <Route path="/timesheet" element={<Timesheet />} />
              <Route path="/partner-relations" element={<AdminPartnerRelations />} />
              <Route path="/help-center" element={<AdminHelpCenter />} />
              <Route path="/interview-requests" element={<AdminInterviewRequests />} />
              <Route path="/submitted-profiles" element={<AdminSubmittedProfiles />} />
              <Route path="/approval-process" element={<ApprovalProcess />} />
              <Route path="issues-feedback" element={<AdminIssuesFeedback />} />
              <Route path="finance" element={<Finance />} />
              <Route path="settings" element={<Settings />} />
              <Route path="account" element={<Account role="admin" />} />
              <Route path="organization/:id" element={<OrganizationProfile />} />
              <Route path="company-details" element={<CompanyDetails />} />
              <Route path="user-profile/:userId" element={<UserProfileView />} />
            </Routes>
          </Layout>
        </Layout>
      </Layout>

      <Modal
        title="Change Password"
        open={changePasswordVisible}
        onOk={handlePasswordSubmit}
        onCancel={() => {
          setChangePasswordVisible(false);
          passwordForm.resetFields();
        }}
        okText="Change Password"
        okButtonProps={{ 
          loading: changingPassword,
          style: { background: "#00d9a9", borderColor: "#00d9a9" } 
        }}
      >
        <Form
          form={passwordForm}
          layout="vertical"
          style={{ marginTop: 16 }}
        >
          <Form.Item
            label="Current Password"
            name="currentPassword"
            rules={[{ required: true, message: "Please enter current password" }]}
          >
            <Input.Password placeholder="Enter current password" />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </Form>
      </Modal>
    </AdminDashboardWrapper>
  );
};

export default Dashboard;
